// extracted by mini-css-extract-plugin
module.exports = {"icon":"ProductIcon_icon__25_NP","dashboard":"ProductIcon_dashboard__3jv7Z","fadeIn":"ProductIcon_fadeIn__3Bm6O","fadeIn2":"ProductIcon_fadeIn2__4S2e0"};